import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="app-footer">
            <div className="container">
                <p>&copy; {t("Copyright Unity Leases")}</p>
            </div>
        </footer>
    );
}
export default Footer;